import { CognitoAuth } from 'amazon-cognito-auth-js';

export let COGNITO_IDENTITY_POOL_ID;
export let COGNITO_IDENTITY_POOL_LOGIN;
export let COGNITO_IDENTITY_POOL_REGION;
export let SNOW_DATA_SERVICE_ENDPOINT;
export let SDS_APIGATEWAY_ENDPOINT;
export let SNOW_DATA_SERVICE_REGION;
export let SNOW_AUTOPOPULATION_SERVICE_REGION;
export let VALIDATE_NODE_PARAMS_API_ENDPOINT;
export let SNOW_VALIDATION_SERVICE_ENDPOINT = '';
export let COGNITO_AUTHENTICATOR;
export let AMAZON_APPROVAL_ENDPOINT;
export let SNOW_NXT_WORKFLOW_ENDPOINT = '';
export let TT_ENDPOINT = '';
export let SIM_ENDPOINT = '';
export let IBFR_STATE_MACHINE_ARN = '';
export let MCM_END_POINT = '';
export const IBFR_WORKFLOW_NAME = 'IBFR_CONFIG_UPDATE_WORKFLOW';
export const IBFR_UPDATE_TASK_ID = 'a4bcbf1f-bcaf-4b5b-b79d-774bb54fff97';
export let BULK_UPLOAD_INPUT_BUCKET;
export let SNOW_AUTOPOPULATION_SERVICE_ENDPOINT;
export let RELEASE_NOTES_CDN_URL;
export let SNOW_CHAT_API_ENDPOINT = '';
export let releaseNotesBucket;
export let releaseNotesBucketRegion;
export let releaseNotesDistributionId;
export const origin = window.location.origin;
export const STAGE = {
	PROD: 'prod',
	TEST: 'test',
	ALPHA: 'alpha',
	GAMMA: 'gamma',
	DEV: 'dev',
};
export let SNOW_NOTIFICATION_SERVICE_ENDPOINT;

const callbackUrl = origin + '/';

export const stage =
	origin == 'https://0.0.0.0:4321'
		? STAGE.DEV
		: origin == 'https://devo.snow.aft.amazon.dev'
		? STAGE.ALPHA
		: origin == 'https://test.snow.aft.amazon.dev'
		? STAGE.TEST
		: origin == 'https://pre-prod.snow.aft.amazon.dev'
		? STAGE.GAMMA
		: STAGE.PROD;
// Helper to check if stage is non-prod (DEV, TEST, ALPHA, GAMMA)
const isNonProdStage = stage == STAGE.DEV || stage == STAGE.TEST || stage == STAGE.ALPHA || stage == STAGE.GAMMA;

export const apiEndPoint =
	stage == STAGE.DEV || stage == STAGE.ALPHA
		? 'https://dev.snow.aft.a2z.com/'
		: stage == STAGE.TEST
		? 'https://test.snow.aft.a2z.com/'
		: stage == STAGE.GAMMA
		? 'https://pre-prod.snow.aft.a2z.com/'
		: 'https://snow.aft.a2z.com/prod/';
export const loggerEndpoint =
	stage == STAGE.PROD
		? 'https://kjcx07gv6a.execute-api.us-east-1.amazonaws.com/prod/v1/log'
		: 'https://njfoqhw83e.execute-api.us-west-2.amazonaws.com/prod/v1/log';
export const s3Bucket =
	isNonProdStage
		? 'p2rworkflowtest'
		: 'p2r-chute-configuration-mappings-for-frs';
export const s3BucketForResources =
	isNonProdStage
		? 'aws-resource-processed-metadata-us-east-1-377581056902'
		: 'aws-resource-processed-metadata-us-east-1-139200550426';
export const dashboardApiEndpoint =
	isNonProdStage
		? apiEndPoint + 'dashboard/'
		: 'https://dl77azn7zf.execute-api.us-east-1.amazonaws.com/prod/';
export const startYear = '2015';
export const currentYear = new Date().getFullYear().toString();
export const currentMonth = new Date().getMonth() + 1;
export const currentWorkflow = 'ALL';
export const supportedWorkflows = [
	'ALL',
	'3PL_WORKFLOW',
	'3PL_SORT_TECH_WORKFLOW',
	'AFT_LITE_SETUP_WORKFLOW',
	'AIR_NODE_SETUP_WORKFLOW',
	'AIR_SORT_TECH_WORKFLOW',
	'DELIVERY_STATION_SETUP_WORKFLOW',
	'DS_SORT_TECH_WORKFLOW',
	'FC_LAUNCH_WORKFLOW',
	'FC_LAUNCH_READY_WORKFLOW',
	'P2R_WORKFLOW',
	'FC_DECOMMISSION_WORKFLOW',
	'KRAKEN_WORKFLOW',
	'MENDEL_SETUP_WORKFLOW',
	'PRIME_NOW_3P_WF_WORKFLOW',
	'SORT_CENTER_SETUP_WORKFLOW',
	'UV_NODE_SETUP_WORKFLOW',
	'EFP_VENDOR_FLEX',
	'VF_SORT_TECH_WORKFLOW',
	'VIRTUAL_DOCK_WORKFLOW',
];

if (stage === STAGE.PROD) {
	//PROD STAGE Application Configs
	SNOW_DATA_SERVICE_ENDPOINT =
		'https://mfkjqhng92.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_DATA_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_ENDPOINT =
		'https://74m55fo9nf.execute-api.us-east-1.amazonaws.com/prod';
	COGNITO_IDENTITY_POOL_ID = 'us-west-2:84fe9edd-88ff-4384-b757-a7fcd725ba98';
	COGNITO_IDENTITY_POOL_LOGIN =
		'cognito-idp.us-west-2.amazonaws.com/us-west-2_wc4ENh35d';
	COGNITO_IDENTITY_POOL_REGION = 'us-west-2';
	VALIDATE_NODE_PARAMS_API_ENDPOINT =
		'https://8o6fsz87zi.execute-api.us-east-1.amazonaws.com';
	COGNITO_AUTHENTICATOR = new CognitoAuth({
		AppWebDomain: 'snowappwebiste.auth.us-west-2.amazoncognito.com',
		ClientId: '4k2b1aid47calsmcs9qe3odnvr',
		RedirectUriSignIn: callbackUrl,
		RedirectUriSignOut: callbackUrl,
		TokenScopesArray: ['openid'],
	});
	TT_ENDPOINT = 'https://t.corp.amazon.com';
	SIM_ENDPOINT = 'https://issues.amazon.com';
	SNOW_NXT_WORKFLOW_ENDPOINT =
		'https://hectd0n6y2.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_VALIDATION_SERVICE_ENDPOINT =
		'https://ws7hzyymm0.execute-api.us-east-1.amazonaws.com/prod';
	SDS_APIGATEWAY_ENDPOINT =
		'https://bjqu4yil35.execute-api.us-east-1.amazonaws.com/prod';
	IBFR_STATE_MACHINE_ARN =
		'arn:aws:states:us-east-1:139200550426:stateMachine:IBFRAutoPopulationStepFunction';
	AMAZON_APPROVAL_ENDPOINT = 'https://approvals.amazon.com';
	BULK_UPLOAD_INPUT_BUCKET = 'bulk-execution-inputs-prod';
	MCM_END_POINT = 'https://mcm.amazon.com/cms/';
	RELEASE_NOTES_CDN_URL = 'https://d14eizlj4euhxg.cloudfront.net';
	releaseNotesBucket = 'snowreleases-prod-bucket-139200550426';
	releaseNotesBucketRegion = 'us-west-2';
	releaseNotesDistributionId = 'E280O57DBQBI9M';
	SNOW_CHAT_API_ENDPOINT =
		'https://9mtuari0jk.execute-api.us-west-2.amazonaws.com/prod/chat';
	SNOW_NOTIFICATION_SERVICE_ENDPOINT = 'https://gzebx8e36i.execute-api.us-west-2.amazonaws.com/prod';
} else if (stage === STAGE.ALPHA) {
	//ALPHA STAGE Application Configs with Federate Integration
	SNOW_DATA_SERVICE_ENDPOINT =
		'https://35n1j693fl.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_DATA_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_REGION = 'us-west-2';
	SNOW_AUTOPOPULATION_SERVICE_ENDPOINT =
		'https://m01s57objc.execute-api.us-west-2.amazonaws.com/alpha';
	COGNITO_IDENTITY_POOL_ID = 'us-east-1:f7ac16d2-6906-4928-94d4-732e09be3ba2';
	COGNITO_IDENTITY_POOL_LOGIN =
		'cognito-idp.us-east-1.amazonaws.com/us-east-1_MYshRWHSh';
	COGNITO_IDENTITY_POOL_REGION = 'us-east-1';
	VALIDATE_NODE_PARAMS_API_ENDPOINT =
		'https://nomakzyoi6.execute-api.us-east-1.amazonaws.com';
	COGNITO_AUTHENTICATOR = new CognitoAuth({
		AppWebDomain: 'snow-website-alpha.auth.us-east-1.amazoncognito.com',
		ClientId: '6nvttvi1m99p7vp4i0r69kkk7q',
		RedirectUriSignIn: callbackUrl,
		RedirectUriSignOut: callbackUrl,
		TokenScopesArray: ['openid'],
		IdentityProvider: 'snow-alpha-useast1',
	});
	TT_ENDPOINT = 'https://tt.amazon.com';
	SIM_ENDPOINT = 'https://issues.amazon.com';
	SNOW_NXT_WORKFLOW_ENDPOINT =
		'https://u1cneow7wb.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_VALIDATION_SERVICE_ENDPOINT =
		'https://ozd8nw7cxb.execute-api.us-east-1.amazonaws.com/prod';
	SDS_APIGATEWAY_ENDPOINT =
		'https://lleqcw38x9.execute-api.us-east-1.amazonaws.com/prod';
	IBFR_STATE_MACHINE_ARN =
		'arn:aws:states:us-east-1:098222644483:stateMachine:IBFRAutoPopulationStepFunction';
	AMAZON_APPROVAL_ENDPOINT = 'https://approvalstage.amazon.com';
	BULK_UPLOAD_INPUT_BUCKET = 'bulk-execution-inputs-alpha';
	MCM_END_POINT = 'https://mcm-beta.amazon.com/cms/';
	RELEASE_NOTES_CDN_URL = 'https://d1anjj4hu1b80h.cloudfront.net';
	releaseNotesBucket = 'snowreleases-alpha-bucket-098222644483';
	releaseNotesBucketRegion = 'us-east-1';
	releaseNotesDistributionId = 'E1ROWDVDWW4DNC';
	SNOW_NOTIFICATION_SERVICE_ENDPOINT = 'https://n7zfl9frq8.execute-api.us-west-2.amazonaws.com/alpha';
	SNOW_CHAT_API_ENDPOINT =
		'https://uvv4jhqc5h.execute-api.us-west-2.amazonaws.com/beta/chat';
} else if (stage === STAGE.GAMMA) {
	//GAMMA STAGE Application Configs with Federate Integration
	SNOW_DATA_SERVICE_ENDPOINT =
		'https://usxwyndz31.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_DATA_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_ENDPOINT =
		'https://rjryui92g5.execute-api.us-east-1.amazonaws.com/gamma';
	COGNITO_IDENTITY_POOL_ID = 'us-east-1:c87ccd42-e181-493e-a09a-712ff83921f8';
	COGNITO_IDENTITY_POOL_LOGIN =
		'cognito-idp.us-east-1.amazonaws.com/us-east-1_HG2pGCzVt';
	COGNITO_IDENTITY_POOL_REGION = 'us-east-1';
	VALIDATE_NODE_PARAMS_API_ENDPOINT =
		'https://qyfocj33mg.execute-api.us-east-1.amazonaws.com';
	COGNITO_AUTHENTICATOR = new CognitoAuth({
		AppWebDomain: 'snow-website-gamma.auth.us-east-1.amazoncognito.com',
		ClientId: '24app66sv5q6khomvmnvmr2ma',
		RedirectUriSignIn: callbackUrl,
		RedirectUriSignOut: callbackUrl,
		TokenScopesArray: ['openid'],
		IdentityProvider: 'snow-gamma-useast1',
	});
	TT_ENDPOINT = 'https://t.corp.amazon.com';
	SIM_ENDPOINT = 'https://issues.amazon.com';
	SNOW_NXT_WORKFLOW_ENDPOINT =
		'https://99ig4g9sbc.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_VALIDATION_SERVICE_ENDPOINT =
		'https://uhfkmtr2oc.execute-api.us-east-1.amazonaws.com/prod';
	SDS_APIGATEWAY_ENDPOINT =
		'https://hfk72gceu2.execute-api.us-east-1.amazonaws.com/prod';
	IBFR_STATE_MACHINE_ARN =
		'arn:aws:states:us-east-1:377581056902:stateMachine:IBFRAutoPopulationStepFunction';
	AMAZON_APPROVAL_ENDPOINT = 'https://approvalstage.amazon.com';
	BULK_UPLOAD_INPUT_BUCKET = 'bulk-execution-inputs-gamma';
	MCM_END_POINT = 'https://mcm-beta.amazon.com/cms/';
	RELEASE_NOTES_CDN_URL = 'https://d3uegnv6yq60i9.cloudfront.net';
	releaseNotesBucket = 'snowreleases-gamma-bucket';
	releaseNotesBucketRegion = 'us-east-1';
	releaseNotesDistributionId = 'E27X4KEIGI4KVV';
	SNOW_NOTIFICATION_SERVICE_ENDPOINT = 'https://16zcfncu6f.execute-api.us-west-2.amazonaws.com/gamma';
	SNOW_CHAT_API_ENDPOINT =
		'https://uvv4jhqc5h.execute-api.us-west-2.amazonaws.com/beta/chat';
} else if (stage === STAGE.TEST) {
	//BETA STAGE Application Configs
	SNOW_DATA_SERVICE_ENDPOINT =
		'https://mwnk7gimzh.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_DATA_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_ENDPOINT =
		'https://0waopzdt14.execute-api.us-east-1.amazonaws.com/beta';
	COGNITO_IDENTITY_POOL_ID = 'us-east-1:3940f22a-df50-4bb8-9787-f9a157e97595';
	COGNITO_IDENTITY_POOL_LOGIN =
		'cognito-idp.us-east-1.amazonaws.com/us-east-1_IeOAK7QyG';
	COGNITO_IDENTITY_POOL_REGION = 'us-east-1';
	VALIDATE_NODE_PARAMS_API_ENDPOINT =
		'https://qyfocj33mg.execute-api.us-east-1.amazonaws.com';
	COGNITO_AUTHENTICATOR = new CognitoAuth({
		AppWebDomain: 'snow-website-beta.auth.us-east-1.amazoncognito.com',
		ClientId: '363tfjkhfa9hlom2esc1jj2m5s',
		RedirectUriSignIn: callbackUrl,
		RedirectUriSignOut: callbackUrl,
		TokenScopesArray: ['openid'],
	});
	TT_ENDPOINT = 'https://t.corp.amazon.com';
	SIM_ENDPOINT = 'https://issues.amazon.com';
	SNOW_NXT_WORKFLOW_ENDPOINT =
		'https://w1uf1yfvyd.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_VALIDATION_SERVICE_ENDPOINT =
		'https://t87upq6uta.execute-api.us-east-1.amazonaws.com/prod';
	SDS_APIGATEWAY_ENDPOINT =
		'https://lleqcw38x9.execute-api.us-east-1.amazonaws.com/prod';
	AMAZON_APPROVAL_ENDPOINT = 'https://approvalstage.amazon.com';
	IBFR_STATE_MACHINE_ARN =
		'arn:aws:states:us-east-1:377581056902:stateMachine:IBFRAutoPopulationStepFunction';
	BULK_UPLOAD_INPUT_BUCKET = 'bulk-execution-inputs-beta';
	MCM_END_POINT = 'https://mcm-beta.amazon.com/cms/';
	RELEASE_NOTES_CDN_URL = 'https://d3uegnv6yq60i9.cloudfront.net';
	releaseNotesBucket = 'snowreleases-beta-bucket-377581056902';
	releaseNotesBucketRegion = 'us-east-1';
	releaseNotesDistributionId = 'E1NL6DBBR29HFI';
	SNOW_CHAT_API_ENDPOINT =
		'https://uvv4jhqc5h.execute-api.us-west-2.amazonaws.com/beta/chat';
	SNOW_NOTIFICATION_SERVICE_ENDPOINT = 'https://03p0048g4h.execute-api.us-west-2.amazonaws.com/beta';
} else {
	//DEV STAGE Application Configs
	SNOW_DATA_SERVICE_ENDPOINT =
		'https://35n1j693fl.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_DATA_SERVICE_REGION = 'us-east-1';
	SNOW_AUTOPOPULATION_SERVICE_REGION = 'us-west-2';
	SNOW_AUTOPOPULATION_SERVICE_ENDPOINT =
		'https://m01s57objc.execute-api.us-west-2.amazonaws.com/alpha';
	COGNITO_IDENTITY_POOL_ID = 'us-east-1:cded03cb-35b1-406e-b7c7-0c53c1f5bead';
	COGNITO_IDENTITY_POOL_LOGIN =
		'cognito-idp.us-east-1.amazonaws.com/us-east-1_JXYNfxc39';
	COGNITO_IDENTITY_POOL_REGION = 'us-east-1';
	VALIDATE_NODE_PARAMS_API_ENDPOINT =
		'https://nomakzyoi6.execute-api.us-east-1.amazonaws.com';
	COGNITO_AUTHENTICATOR = new CognitoAuth({
		AppWebDomain: 'snow-website-devdsk.auth.us-east-1.amazoncognito.com',
		ClientId: '6ee4em5ccgkr3r08pll7n43p0m',
		RedirectUriSignIn: callbackUrl,
		RedirectUriSignOut: callbackUrl,
		TokenScopesArray: ['openid'],
	});
	TT_ENDPOINT = 'https://tt.amazon.com';
	SIM_ENDPOINT = 'https://issues.amazon.com';
	SNOW_NXT_WORKFLOW_ENDPOINT =
		'https://u1cneow7wb.execute-api.us-east-1.amazonaws.com/prod';
	SNOW_VALIDATION_SERVICE_ENDPOINT =
		'https://ozd8nw7cxb.execute-api.us-east-1.amazonaws.com/prod';
	SDS_APIGATEWAY_ENDPOINT =
		'https://lleqcw38x9.execute-api.us-east-1.amazonaws.com/prod';
	IBFR_STATE_MACHINE_ARN =
		'arn:aws:states:us-east-1:377581056902:stateMachine:IBFRAutoPopulationStepFunction';
	AMAZON_APPROVAL_ENDPOINT = 'https://approvalstage.amazon.com';
	BULK_UPLOAD_INPUT_BUCKET = 'bulk-execution-inputs-beta';
	MCM_END_POINT = 'https://mcm-beta.amazon.com/cms/';
	RELEASE_NOTES_CDN_URL = 'https://d1anjj4hu1b80h.cloudfront.net';
	releaseNotesBucket = 'snowreleases-alpha-bucket-098222644483';
	releaseNotesBucketRegion = 'us-east-1';
	SNOW_NOTIFICATION_SERVICE_ENDPOINT = 'https://n7zfl9frq8.execute-api.us-west-2.amazonaws.com/alpha';
	releaseNotesDistributionId = 'EF9VISZHVS1P8';
	SNOW_CHAT_API_ENDPOINT =
		'https://8c8fuqousf.execute-api.us-west-2.amazonaws.com/alpha/chat';
}
